
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import AsyncSelect from 'react-select/async';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


function PurchasePartyandItemWiseReport() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('0');
    const { isAuthenticated, companyId, branchId, userId, permissions, token, username, logout, branchstate } = useAuth();
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, branchId, logout]);

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    // Customer
    const [CustomerTypeOptions, setCustomerTypeOptions] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");
    const [selectedCustomers, setCustomerType] = useState("0");

    const fetchCustomerType = async () => {
        try {
            const response = await fetchData('ReportApi', `/Customer/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(cmr => ({
                    value: cmr.MasterId,
                    label: cmr.Name
                }));
                setCustomerTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching  Raw Type:', error);
        }
    };

    const handleCustomerTypeChange = (selectedOption) => {
        setSelectedCustomerType(selectedOption);
        setCustomerType(selectedOption.value);
    };

    useEffect(() => {
        fetchCustomerType();
    }, []);

    // Item
    const [ItemTypeOptions, setItemTypeOptions] = useState([]);
    const [selectedItemType, setSelectedItemType] = useState("");
    const [selectedItem, setSelectedItem] = useState("0");

    const fetchItemType = async () => {
        try {
            const response = await fetchData('ItemApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(itm => ({
                    value: itm.id,
                    label: itm.name
                }));
                setItemTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching  Item Type:', error);
        }
    };

    const handleItemTypeChange = (selectedOption) => {
        setSelectedItemType(selectedOption);
        setSelectedItem(selectedOption.value);
    };

    useEffect(() => {
        fetchItemType();
    }, []);

    const fetchTableData = async () => {
        setDataItem([])
        try {
            if (PartyandItemWise === "1") {
                const response = await fetchData('ReportApi', `/PurchasePartyWise/${companyId}/${selectedCustomers}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            }
            else if (PartyandItemWise === "2") {
                const response = await fetchData('ReportApi', `/PurchaseItemWise/${companyId}/${selectedItem}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }
    };

    const [PartyandItemWise, setPartyandItemWise] = useState("1");
    const handlesetPartyandItemWiseChange = (event) => {
        setPartyandItemWise(event.target.value);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
    };

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const columnsCustomerWise = [
        { label: "Bill Date" },
        { label: "Bill Number" },
        { label: "Item Name" },
        { label: "Quantity" },
        { label: "Rate" },
        { label: "Taxable Amount" },
        { label: "GST Rate" },
        { label: "GST Amount" },
        { label: "Total Amount" },
    ];



    const handleExportCustomerWiseExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Customer Wise Report');

        // Freeze header rows
        worksheet.views = [{ state: 'frozen', ySplit: 3 }];

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        const thinBorder = {
            top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' }
        };

        // ------------------ REPORT HEADER ------------------
        worksheet.mergeCells('A1:I1');
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `Customer Wise Data | Generated On: ${formattedDateTime} By: ${username}`;
        headerCell.font = { bold: true, size: 12 };
        headerCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

        worksheet.addRow([]);

        // ------------------ COLUMN HEADERS ------------------
        const columns = ['Bill Date', 'Bill No', 'Item Name', 'Quantity', 'Rate', 'Taxable', 'GST %', 'GST Amount', 'Total'];
        const headerRow = worksheet.addRow(columns);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4F81BD' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
        });

        // ------------------ DATA ROWS ------------------
        let previousCustomer = null;
        filteredDataItem.forEach((rowData) => {
            // Customer group row
            if (rowData.MasterName !== previousCustomer) {
                const custRow = worksheet.addRow([`Customer: ${rowData.MasterName}`]);
                custRow.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF4CCCC' } };
                    cell.alignment = { horizontal: 'left' };
                });
                previousCustomer = rowData.MasterName;
            }

            // Data row
            const dataRow = worksheet.addRow([
                formatDate(rowData.BillDate),
                rowData.BillNumber,
                rowData.ItemName,
                rowData.Quantity,
                rowData.Rate,
                rowData.TaxableAmount,
                `${rowData.GSTRate}%`,
                rowData.GSTAmount,
                rowData.TotalAmount
            ]);

            dataRow.eachCell((cell, colNumber) => {
                cell.border = thinBorder;
                if (colNumber >= 4) { // Numeric columns
                    cell.alignment = { horizontal: 'right' };
                    cell.numFmt = '#,##0.00';
                } else { // Text columns
                    cell.alignment = { horizontal: 'left' };
                }
            });
        });

        // ------------------ COLUMN WIDTHS ------------------
        worksheet.columns = [
            { width: 15 }, { width: 12 }, { width: 25 }, { width: 10 },
            { width: 10 }, { width: 12 }, { width: 8 }, { width: 12 }, { width: 12 }
        ];

        // ------------------ SAVE FILE ------------------
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer]),
            `Customer_Wise_Report_From_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
        );
    };


    const columnsItemWise = [
        { label: "Item Name" },
        { label: "Customer Name" },
        { label: "Bill Date" },
        { label: "Bill Number" },
        { label: "Quantity" },
        { label: "Rate" },
        { label: "Taxable Amount" },
        { label: "GST Rate" },
        { label: "GST Amount" },
        { label: "Total Amount" },
    ];

    // const handleExportItemWiseExcel = () => {
    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

    //     const addExcelHeader = (worksheet, title, columns) => {
    //         worksheet.push([`${title} | Generated On: ${formattedDateTime}`]);
    //         worksheet.push([]); // Empty row
    //         worksheet.push(columns.map(col => col.label)); // Column headers
    //     };

    //     const itemWiseSheet = [];

    //     addExcelHeader(itemWiseSheet, 'Item Wise Data', columnsItemWise);

    //     let previousItem = null;

    //     filteredDataItem.forEach(row => {
    //         if (row.ItemName !== previousItem) {
    //             itemWiseSheet.push([`Item: ${row.ItemName}`]);
    //             previousItem = row.ItemName;
    //         }

    //         itemWiseSheet.push([
    //             row.ItemName,
    //             row.MasterName,
    //             row.BillDate,
    //             row.BillNumber,
    //             row.Quantity,
    //             row.Rate.toFixed(2),
    //             row.TaxableAmount.toFixed(2),
    //             `${row.GSTRate}%`,
    //             row.GSTAmount.toFixed(2),
    //             row.TotalAmount.toFixed(2),
    //         ]);
    //     });

    //     itemWiseSheet.push([]); // empty row at the end

    //     const wb = XLSX.utils.book_new();
    //     const itemSheet = XLSX.utils.aoa_to_sheet(itemWiseSheet);

    //     XLSX.utils.book_append_sheet(wb, itemSheet, 'Item Wise Report');
    //     XLSX.writeFile(wb, 'Item_Wise_Report.xlsx');
    // };


    const handleExportItemWiseExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Item Wise Report');

        // Freeze headers (first 3 rows: report title + empty row + column headers)
        worksheet.views = [{ state: 'frozen', ySplit: 3 }];

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        const thinBorder = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

        // ------------------ REPORT HEADER ------------------
        worksheet.mergeCells('A1:J1');
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `Item Wise Data | Generated On: ${formattedDateTime} By: ${username}`;
        headerCell.font = { bold: true, size: 12 };
        headerCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

        worksheet.addRow([]); // Empty row after title

        // ------------------ COLUMN HEADERS ------------------
        const columns = ['Item Name', 'Customer', 'Bill Date', 'Bill No', 'Quantity', 'Rate', 'Taxable', 'GST %', 'GST Amount', 'Total'];
        const headerRow = worksheet.addRow(columns);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4F81BD' } }; // Blue
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
        });

        // ------------------ DATA ROWS ------------------
        let previousItem = null;

        filteredDataItem.forEach((rowData) => {
            // Item group row
            if (rowData.ItemName !== previousItem) {
                const itemRow = worksheet.addRow([`Item: ${rowData.ItemName}`]);
                itemRow.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF4CCCC' } }; // light pink
                    cell.alignment = { horizontal: 'left', vertical: 'center' };
                });
                previousItem = rowData.ItemName;
            }

            // Data row
            const dataRow = worksheet.addRow([
                rowData.ItemName,
                rowData.MasterName,
                formatDate(rowData.BillDate),
                rowData.BillNumber,
                rowData.Quantity,
                rowData.Rate,
                rowData.TaxableAmount,
                `${rowData.GSTRate}%`,
                rowData.GSTAmount,
                rowData.TotalAmount
            ]);

            dataRow.eachCell((cell, colNumber) => {
                cell.border = thinBorder;

                // Numeric columns (Quantity, Rate, Taxable, GST Amount, Total)
                if (colNumber >= 5) {
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                    cell.numFmt = '#,##0.00';
                } else { // Text columns
                    cell.alignment = { horizontal: 'left', vertical: 'middle' };
                }
            });
        });

        // ------------------ COLUMN WIDTHS ------------------
        worksheet.columns = [
            { width: 25 }, { width: 25 }, { width: 15 }, { width: 12 },
            { width: 10 }, { width: 10 }, { width: 12 }, { width: 8 },
            { width: 12 }, { width: 12 }
        ];

        // ------------------ SAVE FILE ------------------
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer]),
            `Item_Wise_Report_From_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
        );
    };


    const cellStyle = {
        borderBottom: '1px solid #ddd',
        color: 'black',
        fontWeight: 'bolder',
        padding: '7px',
        fontSize: '12px',
    };

      const [page, setPage] = useState(0); // Current page
      const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page
    
    
         // Handle page change
        const handlePageChange = (event, newPage) => {
            setPage(newPage);
        };
    
        // Handle rows per page change
        const handleRowsPerPageChange = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset to the first page
        };
    
    
        const processedData = filteredDataItem.slice(
            page * rowsPerPage,
            page * rowsPerPage + rowsPerPage
        );

    return (
        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '-1%' }}>
            <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                {/* Title */}
                <h6
                    className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                >
                    PURCHASE PARTY AND ITEM WISE REPORT
                </h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '32px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>
                <div style={{ display: 'flex', flexWrap: 'nowrap', marginBottom: '16px', marginTop: '1.25%' }}>
                    <div style={{ marginRight: '5', maxWidth: '150px', marginLeft: '10px', marginTop: '-15px' }}>
                        <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="fromDate">
                            From Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            type="date" value={fromDate} onChange={handleFromDateChange} style={{ fontSize: '12.5px' }}
                        />
                    </div>

                    <div style={{ flex: '2', maxWidth: '150px', marginLeft: '8px', marginBottom: '0', marginTop: '-15px' }}>
                        <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="toDate">
                            To Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            type="date" value={toDate} onChange={handleToDateChange} style={{ fontSize: '12.5px' }}
                        />
                    </div>
                    <div className="flex justify-end items-center">
                        <label className="block tracking-wide text-gray-700 mr-0" style={{ marginLeft: '12px' }}>
                            <input
                                type="radio"
                                name="PartyandItemWise"
                                value="1"
                                checked={PartyandItemWise === "1"} // This will check the "PartyWise" radio button by default
                                onChange={handlesetPartyandItemWiseChange}
                            />
                            <span style={{ color: 'blue', fontSize: '12px', marginLeft: '5px', cursor: 'pointer' }}>Party Wise</span>
                        </label>
                        <label className="block tracking-wide text-gray-700 mr-0" style={{ marginLeft: '12px' }}>
                            <input
                                type="radio"
                                name="PartyandItemWise"
                                value="2"
                                checked={PartyandItemWise === "2"} // This will check the "ItemWise" radio button if it's selected
                                onChange={handlesetPartyandItemWiseChange}
                            />
                            <span style={{ color: 'brown', fontSize: '12px', marginLeft: '5px', cursor: 'pointer' }}>Item Wise</span>
                        </label>
                    </div>

                    <Button
                        style={{
                            background: "linear-gradient(to right, #A8A196,#A8A196)",
                            color: "black",
                            textTransform: "none",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
                            maxHeight: "30px",
                            marginLeft: "15px",
                            marginTop: "2.10%",
                            borderRadius: "15px",
                        }}
                        onClick={fetchTableData}
                    >
                        <b style={{ color: 'white' }}>Refresh</b>
                    </Button>

                    {PartyandItemWise === "1" && (
                        <Button
                            style={{
                                background: 'linear-gradient(to right, #3F4F44,#3F4F44)',
                                color: 'black',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',
                                marginTop: '2.10%',
                                borderRadius: "15px",
                            }}
                            onClick={handleExportCustomerWiseExcel}
                        >
                            <b style={{ color: 'white' }}>Excel</b>
                        </Button>
                    )}
                    {PartyandItemWise === "2" && (
                        <Button
                            style={{
                                background: 'linear-gradient(to right, #3F4F44,#3F4F44)',
                                color: 'black',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',
                                marginTop: '2.10%',
                                borderRadius: "15px",
                            }}
                            onClick={handleExportItemWiseExcel}
                        >
                            <b style={{ color: 'white' }}>Excel</b>
                        </Button>
                    )}
                </div>
            </div>
            <div className='w-full mb-5 flex' style={{ maxHeight: '510px', overflowY: 'auto', marginTop: '-15px' }}>

                {PartyandItemWise === "1" && (
                    <TableContainer component={Paper}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        colSpan={10}
                                        sx={{
                                            textTransform: 'uppercase',
                                            backgroundColor: '#E9ECEF', // very light gray-blue
                                            fontSize: '12px',
                                            color: '#333', // soft dark gray text
                                            fontWeight: 'bold',
                                            textAlign: 'center',
                                            padding: '6px',
                                            letterSpacing: '0.5px',
                                        }}
                                    >
                                        Customer Wise Data
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    {[
                                        'Bill Date',
                                        'Bill Number',
                                        'Item Name',
                                        'Quantity',
                                        'Rate',
                                        'Taxable Amount',
                                        'GST Rate',
                                        'GST Amount',
                                        'Total Amount',
                                    ].map((header, i) => (
                                        <TableCell
                                            key={i}
                                            sx={{
                                                padding: '4px',
                                                textTransform: 'uppercase',
                                                backgroundColor: '#F6F6F6', // soft neutral gray
                                                fontSize: '12px',
                                                color: '#4F4F4F',
                                                fontWeight: 'bold',
                                                borderBottom: '1px solid #DDD',
                                                textAlign: i >= 4 ? 'right' : 'left',
                                            }}
                                        >
                                            {header}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {/* Group data by customer */}
                                {Object.entries(
                                    processedData.reduce((acc, item) => {
                                        if (!acc[item.MasterName]) acc[item.MasterName] = [];
                                        acc[item.MasterName].push(item);
                                        return acc;
                                    }, {})
                                ).map(([customerName, items], customerIndex) => {
                                    const subtotalQty = items.reduce((sum, item) => sum + Number(item.Quantity || 0), 0).toFixed(2);
                                    const subtotalRate = items.reduce((sum, item) => sum + Number(item.Rate || 0), 0).toFixed(2);
                                    const subtotalTaxableAmount = items.reduce((sum, item) => sum + Number(item.TaxableAmount || 0), 0).toFixed(2);
                                    const subtotalGSTAmount = items.reduce((sum, item) => sum + Number(item.GSTAmount || 0), 0).toFixed(2);
                                    const subtotalTotalAmount = items.reduce((sum, item) => sum + Number(item.TotalAmount || 0), 0).toFixed(2);

                                    return (
                                        <React.Fragment key={customerIndex}>
                                            {/* Customer Header */}
                                            <TableRow sx={{ backgroundColor: '#F2F2F2' }}>
                                                <TableCell
                                                    colSpan={10}
                                                    sx={{
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                        padding: '4px',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    {customerName}
                                                </TableCell>
                                            </TableRow>


                                            {/* Items for the Customer */}
                                            {items.map((data, index) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        padding: '3px',
                                                        height: '22px',
                                                        backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#FAFAFA', // alternating subtle shade
                                                        ':hover': { backgroundColor: '#F0F0F0' }, // light gray hover
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <TableCell sx={{ textAlign: 'left', padding: '4px 6px', fontSize: '13px' }}>{formatDate(data.BillDate)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'left', padding: '4px 6px', fontSize: '13px' }}>{data.BillNumber}</TableCell>
                                                    <TableCell sx={{ textAlign: 'left', padding: '4px 6px' , fontSize: '13px'}}>{data.ItemName}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center', padding: '4px 6px' , fontSize: '13px'}}>{data.Quantity}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '4px 6px' , fontSize: '13px'}}>{data.Rate.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '4px 6px' , fontSize: '13px'}}>{data.TaxableAmount.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '4px 6px' , fontSize: '13px'}}>{data.GSTRate}%</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '4px 6px', fontSize: '13px' }}>{data.GSTAmount.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '4px 6px' , fontSize: '13px'}}>{data.TotalAmount.toFixed(2)}</TableCell>
                                                </TableRow>
                                            ))}

                                            {/* Subtotal Row */}
                                            <TableRow sx={{ backgroundColor: '#EDEDED' }}>
                                                <TableCell colSpan={3} />
                                                <TableCell sx={{ textAlign: 'center', fontWeight: 'bold', padding: '4px 6px', color: '#333' }}>{subtotalQty}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '4px 6px', color: '#333' }}>{subtotalRate}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '4px 6px', color: '#333' }}>{subtotalTaxableAmount}</TableCell>
                                                <TableCell />
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '4px 6px', color: '#333' }}>{subtotalGSTAmount}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '4px 6px', color: '#333' }}>{subtotalTotalAmount}</TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    );
                                })}
                            </TableBody>

                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[15, 25, 50, 100]}
                                        count={filteredDataItem.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handlePageChange}
                                        onRowsPerPageChange={handleRowsPerPageChange}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>

                )}

                {PartyandItemWise === "2" && (
                    <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid #e0e0e0' }}>
                        <Table stickyHeader>
                            <TableHead sx={{ backgroundColor: '#EAF4EA' }}> {/* Soft green background */}
                                <TableRow>
                                    <TableCell
                                        colSpan={10}
                                        sx={{
                                            textTransform: 'uppercase',
                                            backgroundColor: '#E9ECEF', // light neutral gray-blue
                                            fontSize: '12px',
                                            color: '#333', // soft dark gray text
                                            fontWeight: 'bold',
                                            textAlign: 'center',
                                            padding: '6px',
                                            letterSpacing: '0.5px',
                                        }}
                                    >
                                        Item Wise Data
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    {[
                                        'Item',
                                        'Party',
                                        'Bill Date',
                                        'Bill Number',
                                        'Quantity',
                                        'Rate',
                                        'Taxable Amount',
                                        'GST Rate',
                                        'GST Amount',
                                        'Total Amount',
                                    ].map((header, i) => (
                                        <TableCell
                                            key={i}
                                            sx={{
                                                textTransform: 'uppercase',
                                                backgroundColor: '#F6F6F6', // pale gray, low contrast
                                                borderBottom: '1px solid #DDD',
                                                fontSize: '12px',
                                                color: '#4F4F4F',
                                                padding: '4px',
                                                fontWeight: 'bold',
                                                textAlign: i >= 4 ? 'right' : 'left',
                                            }}
                                        >
                                            {header}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {Object.entries(
                                    processedData.reduce((acc, item) => {
                                        if (!acc[item.ItemName]) acc[item.ItemName] = [];
                                        acc[item.ItemName].push(item);
                                        return acc;
                                    }, {})
                                ).map(([itemName, customers], itemIndex) => {
                                    const subtotalQty = customers.reduce((sum, item) => sum + Number(item.Quantity || 0), 0).toFixed(2);
                                    const subtotalRate = customers.reduce((sum, item) => sum + Number(item.Rate || 0), 0).toFixed(2);
                                    const subtotalTaxableAmount = customers.reduce((sum, item) => sum + Number(item.TaxableAmount || 0), 0).toFixed(2);
                                    const subtotalGSTAmount = customers.reduce((sum, item) => sum + Number(item.GSTAmount || 0), 0).toFixed(2);
                                    const subtotalTotalAmount = customers.reduce((sum, item) => sum + Number(item.TotalAmount || 0), 0).toFixed(2);

                                    return (
                                        <React.Fragment key={itemIndex}>
                                            {/* Item Header */}
                                            <TableRow sx={{ backgroundColor: '#F2F2F2' }}>
                                                <TableCell
                                                    colSpan={10}
                                                    sx={{
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                        padding: '5px',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    {itemName}
                                                </TableCell>
                                            </TableRow>

                                            {/* Customers under the Item */}
                                            {customers.map((data, index) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        padding: '3px',
                                                        height: '20px',
                                                        backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#FAFAFA', // alternating light rows
                                                        ':hover': { backgroundColor: '#F0F0F0' }, // gentle hover shade
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <TableCell />
                                                    <TableCell sx={{ textAlign: 'left', padding: '4px 6px', fontSize: '13px' }}>{data.MasterName}</TableCell>
                                                    <TableCell sx={{ textAlign: 'left', padding: '4px 6px' , fontSize: '13px'}}>{formatDate(data.BillDate)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'left', padding: '4px 6px' , fontSize: '13px'}}>{data.BillNumber}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center', padding: '4px 6px' , fontSize: '13px'}}>{data.Quantity}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '4px 6px', fontSize: '13px' }}>{data.Rate.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '4px 6px' , fontSize: '13px'}}>{data.TaxableAmount.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '4px 6px' , fontSize: '13px'}}>{data.GSTRate}%</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '4px 6px' , fontSize: '13px'}}>{data.GSTAmount.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '4px 6px' , fontSize: '13px'}}>{data.TotalAmount.toFixed(2)}</TableCell>
                                                </TableRow>
                                            ))}

                                            {/* Subtotal Row */}
                                            <TableRow sx={{ backgroundColor: '#EDEDED' }}>
                                                <TableCell colSpan={4} />
                                                <TableCell sx={{ textAlign: 'center', fontWeight: 'bold', padding: '4px 6px', color: '#333' }}>{subtotalQty}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '4px 6px', color: '#333' }}>{subtotalRate}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '4px 6px', color: '#333' }}>{subtotalTaxableAmount}</TableCell>
                                                <TableCell />
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '4px 6px', color: '#333' }}>{subtotalGSTAmount}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '4px 6px', color: '#333' }}>{subtotalTotalAmount}</TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    );
                                })}
                            </TableBody>

                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[15, 25, 50, 100]}
                                        count={filteredDataItem.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handlePageChange}
                                        onRowsPerPageChange={handleRowsPerPageChange}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>

                )}
            </div>
        </div>
    );
}

export default PurchasePartyandItemWiseReport;
